<article *ngIf="pages">
  <div class="row">
    <div class="col-md-10 offset-md-1 info col-xm-12" [innerHTML]="pages[0].content" style="font-size:1.5em;margin-bottom:50px;"></div>
  </div>
</article>
